import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_TARIFF_SIMULATION_RELEASE_ORDER: {
      return { ...state, ...action.value };
    }
    default:
      return state;
  }
};
